module.exports = __webpack_public_path__ + "static/img/szrhome.e8a5a91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szrhome.png
// module id = xb3k
// module chunks = 0